<script setup lang="ts">
  import type { IconName } from './types'

  export interface IconProps {
    name: IconName
    size?: number
    color?: string
  }

  withDefaults(defineProps<IconProps>(), {
    size: 24,
    color: 'currentColor',
  })
</script>

<template>
  <span
    :class="`icon-${name}`"
    :style="{
      fontSize: `${size}px`,
      color: color,
    }"
  />
</template>

<style scoped></style>
